import { FormGroup, FormControl, FormArray, AbstractControl } from '@angular/forms';

export class AppValidationsHelper {

  public static validateFormFields(formGroup: FormGroup) {
    Object.keys(formGroup.controls).forEach(field => {
      const control = formGroup.get(field);
      if (control instanceof FormControl || control instanceof FormArray) {
        control.markAsTouched({ onlySelf: true });
      } else if (control instanceof FormGroup) {
        this.validateFormFields(control);
      }
    });
  }

  public static PasswordValidator(ac: AbstractControl) {
    var regexp = /^(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])(?=.*[!@#$%^&*\(\)_\-+=\{\}\[\]|:;"'<>,.\?/~`\\])[a-zA-Z0-9!@#$%^&*\(\)_\-+=\{\}\[\]|:;"'<>,.\?/~`\\]{12,}$/;
    let userId = !!ac.get('id') ? ac.get('id').value : null;
    if (!userId) {
      let password = ac.get('password').value;
      let confirmPassword = ac.get('confirmPassword').value;
      let firstName = ac.get('firstName').value;
      let lastName = ac.get('lastName').value;

      ac.get('password').setErrors(null);

      if (!password || !password.match(regexp)) {
        ac.get('password').setErrors({ invalid: true });
      }

      if (password && password.length > 0 && firstName && firstName.length > 0 
        && password.toLowerCase().indexOf(firstName.toLowerCase()) !== -1) {
        ac.get('password').setErrors({ invalid: true });
      }

      if (password && password.length > 0 && lastName && lastName.length > 0 
        && password.toLowerCase().indexOf(lastName.toLowerCase()) !== -1) {
        ac.get('password').setErrors({ invalid: true });
      }

      if (password !== confirmPassword) {
        ac.get('confirmPassword').setErrors({ matchingPassword: true });
      }
    }
  }

}
